export default {
  errorDefault: 'Įvyko klaida',
  unknown: 'Nežinoma',
};
